import { GusDialogConfig } from '@shared/modules/dialog/models/dialog.models';

export const COLLECTION_SUBSCRIPTION_DIALOG_CONFIG: GusDialogConfig = {
  title: 'Collection Subscription',
  hasCloseButton: true,
};
